package com.eladfinish.bible.contest.platform

import kotlinx.browser.window

class WebPlatform : Platform {
    override val name: String = window.navigator.userAgent
}

actual fun getPlatform(): Platform = WebPlatform()

actual fun getLineSeparator(): String = "\n"

/**
 * Free-text/phrase search (unlike root or number search) needs to know which chapter files
 * exist under a directory before it can scan them (see GetSearchedChaptersUseCase). This used
 * to always return emptyList(), silently breaking whole-Bible phrase search on web. Uses the
 * same webpack `require.context` mechanism as AssetReaderImpl.js.kt to enumerate the bundled
 * asset paths — moko's generated `assets.values()` only lists top-level files on Kotlin/JS, not
 * anything nested under a category folder like "allChapters".
 */
actual class FileListFetcher {
    actual fun fetchFileList(directory: String): List<String> {
        val prefix = "./$directory/"
        val keys = assetsContext.keys() as Array<String>
        return keys.filter { it.startsWith(prefix) }.map { it.removePrefix(prefix) }
    }

    private companion object {
        val assetsContext: dynamic =
            js("require.context('./assets', true, /\\.(txt|json|csv|html|ttf)$/)")
    }
}

actual fun buildSignature(): String = "WEB_SIGNATURE__2026-09-04__A"
